import type { Track } from "../constants/tracks.constant";
import { VinylIcon } from "./icons/vinyl-icon.component";

interface TrackRowProps {
  track: Track;
  index: number;
  isPlaying: boolean;
  currentTime?: number;
  onClick: () => void;
}

function formatDuration(seconds: number): string {
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${m}:${String(s).padStart(2, "0")}`;
}

export function TrackRow({ track, index, isPlaying, currentTime, onClick }: TrackRowProps) {
  return (
    <div
      className="grid grid-cols-[52px_72px_1fr_auto] items-center py-3.5 border-b border-border-light last:border-b-0 cursor-pointer transition-colors duration-200"
      onClick={onClick}
      role="button"
      tabIndex={0}
    >
      <span className="text-xs tracking-wider transition-colors duration-200 text-muted">
        {String(index + 1).padStart(2, "0")}
      </span>
      <VinylIcon isPlaying={isPlaying} />
      <div className="flex flex-col gap-1">
        <span className="text-base font-bold tracking-tight transition-colors duration-200 text-white">
          {track.title}
        </span>
        <span className="text-xs text-muted tracking-widest uppercase">
          {track.genre.join(" / ")}
        </span>
      </div>
      <span className="text-sm text-muted tracking-wider tabular-nums">
        <span className="md:hidden">
          {currentTime !== undefined
            ? formatDuration(currentTime)
            : formatDuration(track.durationSeconds)}
        </span>
        <span className="hidden md:inline">
          {currentTime !== undefined
            ? `${formatDuration(currentTime)} / ${formatDuration(track.durationSeconds)}`
            : formatDuration(track.durationSeconds)}
        </span>
      </span>
    </div>
  );
}
